import type { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

import { StudioExecutionColumnTypes } from '@blockworks/platform/api/research/studio/execution';
import { StudioVisualizationType } from '@blockworks/platform/api/research/studio/visualizations';
import { nanoid } from '@blockworks/platform/libs/nanoid';

import { FormatValue } from '../../../../format';
import type { GetVisualizationPropsResponse } from '../../../models';
import { LoadingCell } from '../loading-cell';

type Opts = GetVisualizationPropsResponse<StudioVisualizationType.Table>['options'];

const GLOBAL_SEARCH_COL_ID = `global-${nanoid()}`;
const SYNTHETIC_GLOBAL_SEARCH_COL = {
    colId: GLOBAL_SEARCH_COL_ID,
    field: GLOBAL_SEARCH_COL_ID,
    suppressColumnsToolPanel: true,
    hide: true,
    filter: 'agTextColumnFilter',
} satisfies ColDef;

const makeColumns = (
    cols: Opts['groups'][number]['columns'],
    columnTypes: Record<string, StudioExecutionColumnTypes> = {},
    options: GetVisualizationPropsResponse<StudioVisualizationType.Table>['options'],
): ColDef[] => {
    const columns: ColDef[] = [SYNTHETIC_GLOBAL_SEARCH_COL];

    for (let idx = 0; idx < cols.length; idx++) {
        const col = { ...cols[idx]! };

        const config: ColDef = {
            colId: col.key,
            field: col.key,
            headerName: col.header,
            sortable: col.sortable,
            suppressHeaderMenuButton: !col.sortable,
            suppressColumnsToolPanel: !col.sortable,
            suppressMovable: true,
            enableRowGroup: false,
            resizable: !!options.enableResizableColumns,
            filter: false,
            flex: 1,
            menuTabs: ['generalMenuTab'],
            cellRenderer: (props: ICellRendererParams) => {
                return (
                    <FormatValue
                        display="inline-flex"
                        d3Format={col.format}
                        hasNegativeColor={col.hasNegativeColor}
                        hasPositiveColor={col.hasPositiveColor}
                        isMarkdown={col.isMarkdown}
                        type={columnTypes[col.key]}
                        value={props.value}
                    />
                );
            },
            loadingCellRenderer: LoadingCell,
        };
        columns.push(config);
    }
    return columns;
};

export { makeColumns, SYNTHETIC_GLOBAL_SEARCH_COL };
